<template>
<form novalidate @submit.stop.prevent="addLayer" class="ql-new-layer-form">
    <h2 class="md-title">Add a New Layer</h2>
    <md-input-container :class="{'md-input-container-invalid': isNewLayerTitleInvalid}" style="margin: 0px 0 0px !important;">
        <label for="layer-title">Layer Title</label>
        <md-input id="layer-title" required v-model="newLayerTitle" :class="{'invalid-input': isNewLayerTitleInvalid}" @input="validateLayerTitle"></md-input>
    </md-input-container>
    <span v-if="isNewLayerTitleInvalid" class="error-message">Enter the Layer title.</span>
    <br/>
    <div class="property-box" style="padding: 0 0px 0px !important;">
        <div class="property-title">
            <span class="title">Color</span>
            <div class="current-color-box" :style="{backgroundColor: this.color}"></div>
        </div>
        <div class="property-content note_color">
            <template>
                <div class="color-swatches">
                    <div class="color-box color-box-black" @click="pickSpecificColor('#000000')"></div>
                    <div class="color-box color-box-red" @click="pickSpecificColor('#ff0000')"></div>
                    <div class="color-box color-box-green" @click="pickSpecificColor('#00ff00')"></div>
                    <div class="color-box color-box-blue" @click="pickSpecificColor('#0000ff')"></div>
                </div>
                <color-picker v-model="color" @input="pickColor" />
            </template>
        </div>
    </div>
    <br />
    <md-button class="md-raised md-primary" @click="addLayer">Add Layer</md-button>
</form>
</template>

<script>
import { Slider } from 'vue-color';
import { mapGetters } from 'vuex';

const LayersLayerNew = {
    name: 'LayersLayerNew',
    props: [],
    data: function() {
        return {
            newLayerTitle: '',
            color: '#000000',
            colors: {},
            isNewLayerTitleInvalid: false,
            defaultCueMarker: 'position',
            defaultCuePlacement: 'right',
            titleFontSize: 14,
            attributes: {
                label: true
            },
            headerBox: {
                title: true,
                label: true,
                time: false
            },
            userDefined: {
                user1: { label: 'User 1', value: false },
                user2: { label: 'User 2', value: false },
                user3: { label: 'User 3', value: false },
                user4: { label: 'User 4', value: false }
            }
        };
    },
    computed: {
        ...mapGetters([
            'project',
            'user'
        ])
    },
    methods: {
        validateLayerTitle() {
            this.isNewLayerTitleInvalid = !this.newLayerTitle.trim();
        },
        addLayer() {
            this.isNewLayerTitleInvalid = !this.newLayerTitle;

            if (this.isNewLayerTitleInvalid) {
                return;
            }

            const newLayer = {
                title: this.newLayerTitle,
                color: this.color || '#000000',
                defaultCueMarker: 'position',
                defaultCuePlacement: this.user.projects[this.project.id].cuePlacement === 'right' ? 'right' : 'left',
                defaultTextStampBackground: 'nofill',
                titleFontSize: this.titleFontSize,
                attributes: {label: true},
                headerBox: {title: true, label: true, time: false}
            };
            this.$emit('addLayer', newLayer);

            this.newLayerTitle = '';
            this.color = '';
            this.colors = {};
            this.defaultCueMarker = 'position';
            this.defaultCuePlacement = this.user.projects[this.project.id].cuePlacement === 'right' ? 'right' : 'left';
            this.defaultTextStampBackground = 'nofill';
            this.attributes = {label: true};
            this.headerBox = {title: true, label: true, time: false};

            this.resetForm();
        },
        resetForm() {
            this.newLayerTitle = '';
            this.color = '#000000';
            this.colors = {};
            this.isNewLayerTitleInvalid = false;
        },
        pickColor(e) {
            this.color = (e && e.hex) || '';
        },
        pickSpecificColor(color) {
            this.$nextTick(() => {
                this.color = color;
            });
        }
    },
    components: {
        'color-picker': Slider
    }
};
export default LayersLayerNew;

</script>

<style lang="scss">
.ql-new-layer-form {
    padding: 1em;
    .ql-color-picker {
        width: 100%;
        display: block;
        clear: both;
    }
    .color-swatches {
        flex: 1;
        max-width: 80px;
        display: flex;
        flex-wrap: wrap;
        .color-box {
            display: block;
            width: 32px;
            height: 32px;
            cursor: pointer;
            &.color-box-black {
                background: #000;
                border: double 4px #fff;
            }
            &.color-box-red {
                background: #f00;
                border: double 4px #fff;
            }
            &.color-box-green {
                background: #0f0;
                border: double 4px #fff;
            }
            &.color-box-blue {
                background: #00f;
                border: double 4px #fff;
            }
        }
    }

    .error-message {
        color: red;
        font-size: 12px;
        margin-top: 5px;
    }

    .invalid-input {
        border: 2px solid red;
    }

    .md-input-container-invalid .md-input {
        border-color: red !important;
        border-top: none;
        border-left: none;
        border-right: none;
    }
}

.property-box {
    padding: 0 16px 12px;
    .property-content {
        margin: 8px 0;
        display: flex;
        flex-wrap: wrap;
        .md-radio {
            width: 100%;
            margin: 4px 0;
        }
        .md-checkbox {
            margin: 4px 0;
            flex: 1 0 50%;
            label {
                white-space: nowrap;
            }
        }
        .property-box {
            padding-left: 6px;
            padding-right: 0;
        }
    }
    .note_color {
        display: flex;
        align-items: center;
        .vc-slider {
            flex: 1;
        }
    }
}

</style>


// WEBPACK FOOTER //
// layer-new.vue?48eb0e5e